import { useState } from 'react';
import useContactStore from '@/stores/ContactStore';
import useInboxStore from '@/stores/InboxStore';
import useUserStore from '@/stores/UserStore';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

import { updateBulkContactStatus } from '@/hooks/contact';

import { Button } from '../ui/button';

const BulkArchiveChatButton = () => {
  const [loading, setLoading] = useState(false);
  const clientId = useUserStore((state) => state.clientId);
  const {
    setBulkContactStatus,
    removeBulkConversation,
    selectedConversations,
    selectedConversationStatus,
    decreaseBulkConversationCount,
    clearSelection,
    toggleMultiSelectMode,
  } = useInboxStore(
    useShallow((state) => ({
      setBulkContactStatus: state.setBulkContactStatus,
      removeBulkConversation: state.removeBulkConversation,
      selectedConversations: state.selectedConversations,
      selectedConversationStatus: state.selectedConversationStatus,
      decreaseBulkConversationCount: state.decreaseBulkConversationCount,
      clearSelection: state.clearSelection,
      toggleMultiSelectMode: state.toggleMultiSelectMode,
    }))
  );
  const { currentContactId, setContactStatus } = useContactStore(
    useShallow((state) => ({
      currentContactId: state._id,
      setContactStatus: state.setContactStatus,
    }))
  );

  if (!selectedConversations || selectedConversations.length === 0) {
    return null;
  }

  const bulkArchiveChats = async () => {
    try {
      setLoading(true);

      const response = await updateBulkContactStatus(
        selectedConversations,
        'close',
        clientId
      );
      // Update the status of the conversations that are moved to archive
      setBulkContactStatus(selectedConversations, 'close');
      // If current selected contact is part of the conversationIds, update the status
      if (currentContactId) {
        setContactStatus('close');
      }

      if (selectedConversationStatus.value !== 'all') {
        // Remove the conversations that belong to "open" status from the list
        removeBulkConversation(selectedConversations);
        decreaseBulkConversationCount(selectedConversations.length);
      }

      clearSelection();
      toggleMultiSelectMode();

      toast.success('Chats archived successfully');
    } catch (error) {
      toast.error('Unable to update contact status');
    }
    setLoading(false);
  };

  return (
    <div className='border-b bg-background/50 p-2'>
      <div className='flex items-center justify-between'>
        <span className='text-sm text-muted-foreground'>
          {selectedConversations.length} selected
        </span>
        <Button
          variant='outline'
          size='xs'
          className='w-[150px] rounded px-2 py-1 text-sm text-primary transition-colors hover:bg-secondary hover:text-primary'
          onClick={bulkArchiveChats}
          disabled={selectedConversationStatus.value === 'close' || loading}
        >
          {loading
            ? 'Archiving...'
            : `Archive Chats (${selectedConversations.length})`}
        </Button>
      </div>
    </div>
  );
};

export default BulkArchiveChatButton;
